var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.classList,
      attrs: { type: _vm.type },
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm.loading ? _c("ui-loader", { attrs: { fill: "#fff" } }) : _vm._e(),
      _c(
        "div",
        { staticClass: "ui-button-content" },
        [
          _vm.count
            ? _c("ui-badge", {
                staticClass: "ui-button-count",
                attrs: { text: _vm.count }
              })
            : _vm._e(),
          _vm.icon && !_vm.count
            ? _c("f-sprite-icon", { attrs: { "icon-link": _vm.icon } })
            : _vm._e(),
          _vm._v("\n    " + _vm._s(_vm.text) + "\n  ")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }